var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pr age-wrap"},[_c('div',{staticStyle:{"height":"300px"},attrs:{"id":"age-chart"}}),_vm._l((_vm.fields),function(item,index){return _c('p',{key:index,staticClass:"pa w-100 text-a-c f-12",class:index == 0 ? 'top' : 'bottom'},[_c('span',[_vm._v(_vm._s(item.name))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }